import { useState } from 'react'

export default function Component() {
  const [file, setFile] = useState(null)
  const [schedule, setSchedule] = useState(null)

  const handleFileChange = (e) => {
    if (e.target.files) {
      setFile(e.target.files[0])
    }
  }

  const generateSchedule = () => {
    // This is where you would implement the actual schedule generation logic
    // For now, we'll just set a placeholder message
    setSchedule("Schedule generated based on uploaded Excel file.")
  }

  return (
    <div className="min-h-screen bg-amber-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <div className="bg-white shadow-md rounded-lg overflow-hidden mb-8">
          <div className="p-6 sm:p-8">
            <div className="flex items-center mb-6">
              <img
                src="https://shorturl.at/StLVP"
                alt="Manager"
                className="w-20 h-20 rounded-full mr-4"
              />
              <h1 className="text-2xl font-bold text-gray-900">Sanyo Fonseca</h1>
            </div>
            <p className="text-gray-600 mb-4">Manager</p>
          </div>
        </div>

        <div className="bg-white shadow-md rounded-lg overflow-hidden mb-8">
          <div className="p-6 sm:p-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">Upload Excel File</h2>
            <div className="flex items-center justify-between">
              <input
                type="file"
                accept=".xlsx, .xls"
                onChange={handleFileChange}
                className="block w-full text-sm text-gray-500
                  file:mr-4 file:py-2 file:px-4
                  file:rounded-full file:border-0
                  file:text-sm file:font-semibold
                  file:bg-blue-50 file:text-blue-700
                  hover:file:bg-blue-100"
              />
              <button
                onClick={generateSchedule}
                disabled={!file}
                className="ml-4 px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:ring-amber-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500 disabled:bg-gray-300 disabled:cursor-not-allowed"
              >
                Generate Schedule
              </button>
            </div>
          </div>
        </div>

        <div className="bg-white shadow-md rounded-lg overflow-hidden">
          <div className="p-6 sm:p-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">Generated Schedule</h2>
            {schedule ? (
              <p className="text-gray-600">{schedule}</p>
            ) : (
              <p className="text-gray-400 italic">No schedule generated yet. Upload an Excel file and click "Generate Schedule" to create a schedule.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}